var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomBriefcase = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/custom/briefcase") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L30,0 L30,30 L0,30 L0,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/custom/briefcase",
    stroke: "none",
    fill: "none",
    xlinkHref: "#path-1",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_work_48px-copy",
    transform: "translate(4.8, 4.8)",
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6624,4.1472 L14.5152,4.1472 L14.5152,2.0736 C14.5152,0.927936 13.587264,0 12.4416,0 L8.2944,0 C7.148736,0 6.2208,0.927936 6.2208,2.0736 L6.2208,4.1472 L2.0736,4.1472 C0.927936,4.1472 0.010368,5.075136 0.010368,6.2208 L0,17.6256 C0,18.771264 0.927936,19.6992 2.0736,19.6992 L18.6624,19.6992 C19.808064,19.6992 20.736,18.771264 20.736,17.6256 L20.736,6.2208 C20.736,5.075136 19.808064,4.1472 18.6624,4.1472 Z M12.4416,4.1472 L8.2944,4.1472 L8.2944,2.0736 L12.4416,2.0736 L12.4416,4.1472 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomBriefcase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-briefcase.b8af1e44bd455acab7fd594ee66f7782.svg";